export default __webpack_public_path__ + "static/media/lipsticks.ab6225df.jpg";